import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icon from '../../../components/Icon';
export const Search = ({ search, updateSearch }) => {
    return _jsxs("div", { className: 'repositories__search', children: [_jsx("input", { type: 'text', className: 'form-control', placeholder: 'Search', value: search, onChange: updateSearch, "data-testid": "search-input" }), !search ? null : (_jsx("button", { className: 'repositories__search-clear btn btn-link', onClick: () => updateSearch(''), "data-testid": "search-clear", children: _jsx(Icon, { name: 'times' }) }))] });
};
